import React from "react";
import Skeleton from "react-loading-skeleton";
import { ScrollView, View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";

const ButtonsSkeleton = ({ number = 7 }) => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(number).fill(0);

  return skeletonCards.map((index) => (
    <View
      style={{
        width:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 150
            : 125,
      }}
    >
      <Skeletons
        height={40}
        style={{
          borderRadius: 10,
        }}
      />
    </View>
  ));
};

export default ButtonsSkeleton;
